<template>
    <div class="row">
        <div class="col-12 mb-0">
            <h5>Başvuru Bilgileri</h5>
            <div class="table-responsive mb-0">
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>Başvuru No</th>
                            <th>Kredi Kartı</th>
                            <th>Teslim Edilecek Kişi</th>
                            <th>İşlemi Yapan</th>
                            <th>İşlem Tarihi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{value.ApplicationCode || "-"}}</td>
                            <td>{{value.CreditCardNumber || "-"}}</td>
                            <td>{{value.DeliveryPersonFullName || "-"}}</td>
                            <td>{{value.CreatedBy || "-"}}</td>
                            <td>{{value.SentTime || "-"}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-12" v-if="value.IsSent">
            <hr/>
            <h5>Başvuru Metin İçeriği</h5>
            <div class="ql-editor h-auto" v-html="value.ApplicationText"></div>
            <hr/>
        </div>
        <div class="col-12" :class="{'mt-1':!value.IsSent}">
            <h5>Plaka Bilgileri</h5>
            <div class="table-responsive mb-0">
                <table class="table table-sm table-bordered mb-0">
                    <thead>
                        <tr>
                            <th>Plaka</th>
                            <th>Plaka Sınıfı</th>
                            <th>İlk Yükleme Tutarı</th>
                            <th>Oto. Yükleme Miktarı</th>
                            <th>Min. Yükleme Miktarı</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(plate,index) in value.PlatesOfHGSApplications" :key="index">
                            <td>{{plate.PlateNumber || "-"}}</td>
                            <td>{{plate.PlateClass || "-"}}</td>
                            <td>{{plate.FirstLoadAmount || "-"}}</td>
                            <td>{{plate.AutomaticLoadAmountLimit || "-"}}</td>
                            <td>{{plate.MinimumLoadAmount || "-"}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
}
</script>

<style>

</style>